import React, { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { GET_MATHS_MODULE_REPORT_BY_STUDENT } from "../../../../../app/service/mns-service";
import { toast } from "react-toastify";
import { MATHS_REPORT_DOWNLOAD } from "../../../../../app/service/maths-reports";
import { MNSReport } from "../../../../../components/maths-reports/mns";
import { MLAOneReport } from "../../../../../components/maths-reports/mla-one";
import { MLATwoReport } from "../../../../../components/maths-reports/mla-two";
import MathsReportData from "../../../../../components/maths-reports/view-report";
import axios from "axios";
export const StudentMathsReportView = () => {
    const [loading, setLoading] = useState(false);
    let { userCode } = useParams<{ userCode: string }>();
    const [reportInfo, setReportInfo] = useState<any>({});
    const pdfRef = useRef<HTMLDivElement>(null);
    const currentUrl = window.location.href.split('#')[0];

    useEffect(() => {
        getReports();
    }, []);
    const getReports = () => {
        setLoading(true);
        GET_MATHS_MODULE_REPORT_BY_STUDENT(userCode).then((res: any) => {
            if (res) {
                if (res.status === 'fail') {
                    toast.error(res.message);
                    setLoading(false);
                } else {
                    setReportInfo(res);
                    setLoading(false);
                }

            }
        })
    }

    const handleClick = () => {
        let payLoad = {
            url: `${currentUrl}#/student-dashboard/list/maths/reports/student/${userCode}`,
            user_code: userCode,
            token: localStorage.getItem("token")
        }
        setLoading(true);
        MATHS_REPORT_DOWNLOAD(payLoad).then((res: any) => {
            if (res) {
                if (res.status === 'fail') {
                    toast.error(res.message);
                    setLoading(false);
                } else {
                    setLoading(false);
                    handleDownload(res?.complete_url);

                }

            }
        })

    };



    const handleDownload = async (Url: any) => {
        try {
            const response = await axios.get(Url, {
                responseType: 'blob',
            });

            // Create a blob from the response data
            const blob = new Blob([response.data], { type: 'application/pdf' });

            // Create a link element
            const link = document.createElement('a');

            // Create a URL for the blob
            const url = window.URL.createObjectURL(blob);

            // Set link attributes
            link.href = url;
            link.download = `${reportInfo?.user_name}_${reportInfo?.standard}th_MathReport.pdf`;  // You can set the file name here

            // Append link to the body
            document.body.appendChild(link);

            // Programmatically click the link to trigger the download
            link.click();

            // Clean up
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error downloading the PDF', error);
        }
        // try {
        //     const response = await fetch(Url);
        //     const blob = await response.blob();
        //     const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/pdf' })); // Explicitly setting type for PDF files
        //     const link = document.createElement('a');
        //     link.href = url;
        //     link.setAttribute('download', `${reportInfo?.user_name?.substring(0, 8)}_${reportInfo?.standard}th_MathReport.pdf`);
        //     document.body.appendChild(link);
        //     link.click();
        // } catch (error) {
        //     console.error('Error downloading file:', error);
        // }
    };

    const convertDecimalToTime = (value: any): string => {
        const totalSeconds = Math.round(value * 60); // Convert decimal to total seconds
        const minutes = Math.floor(totalSeconds / 60); // Extract minutes
        const seconds = totalSeconds % 60;
        return `${minutes}${seconds > 0 ? `.${seconds < 10 ? `0${seconds}` : seconds}` : ""}`;
    };

    return (
        <>
            {loading &&
                <div className="text-center p-5">
                    <div className="spinner-border" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            }
            {!loading && <div>
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb pb-2 ps-0 pt-0 border-bottom">
                        <li className="breadcrumb-item "><Link to="/student-dashboard/list"><span className='pe-2'>Dashboard</span></Link></li> /
                        <li className="breadcrumb-item "><span>Maths Report</span></li>
                    </ol>
                </nav>
                <div className="mt-3 text-end me-5">
                    <button className="btn btn-primary px-3 py-1" id="MATH_REPORT_DOWNLOAD" onClick={handleClick}>Download </button>
                </div>
                <div ref={pdfRef} id="download-content">
                    <div className="report_border mx-lg-5 mx-2 mt-3 mb-5 px-lg-4 px-1 py-3">
                        <div className="d-flex justify-content-end "><i className="report_ias_icon " style={{ width: "80px" }}></i></div>
                        <MathsReportData reportInfo={reportInfo} />
                        <div className="mx-lg-3">
                            <MNSReport mnsReportInfo={reportInfo?.mnsDetails} />
                            <MLAOneReport mlaOneReportInfo={reportInfo?.mlaOneDetails} />
                            <MLATwoReport mlaTwoReportInfo={reportInfo?.mlaTwoDetails} />
                        </div>
                    </div>
                </div>
            </div>}
        </>
    )
}
